module.exports = ".both_logos img {display: inline-block;max-width:203px;width:100%;}\n.l7.agencymatrix_integration_settings { margin-bottom: 10px;}"